<div class="append-container" style="height: 30px;" #container></div>
            <form class="k-form k-form-horizontal" style="max-width: 700px;width: 700px;" [formGroup]="formGroup">
                <fieldset class="k-form-fieldset">
               
                    <kendo-formfield orientation="horizontal">
                        <kendo-label class="k-label" [for]="identificacao" [text]="customMsgService.translate('identificacao')"> </kendo-label>
                        <kendo-textbox formControlName="identificacao" [clearButton]="true" #identificacao required> </kendo-textbox>
                        <kendo-formerror>  {{ customMsgService.translate('error') }}: {{ customMsgService.translate('theField') }}  {{ customMsgService.translate('identificacao') }}   {{ customMsgService.translate('isRequired') }}</kendo-formerror>

                    </kendo-formfield>

                    <kendo-formfield orientation="horizontal">
                        <kendo-label [for]="numeroDeSerie" [text]="customMsgService.translate('numeroDeSerie')"> </kendo-label>
                        <kendo-textbox formControlName="numeroDeSerie" [clearButton]="true" #numeroDeSerie required> </kendo-textbox>
                        <kendo-formerror>  {{ customMsgService.translate('error') }}: {{ customMsgService.translate('theField') }}  {{ customMsgService.translate('numeroDeSerie') }}   {{ customMsgService.translate('isRequired') }}</kendo-formerror>
                       
                    </kendo-formfield>
                
                 

                    <kendo-formfield orientation="horizontal">
                        <kendo-label class="k-label" [for]="refTipoFerramenta"  [text]="customMsgService.translate('tooltype')"> </kendo-label>
                        <kendo-dropdownlist formControlName="refTipoFerramenta"
                        textField="nome"
                        valueField="id"
                        formControlName="refTipoFerramenta" 
                        
                        [defaultItem]="placeHolderTipoFerramenta"
                        (selectionChange)="selectionChange($event)"
                        [data]="listItemsTipos" #refTipoFerramenta required>
                        </kendo-dropdownlist>
                        <kendo-formerror>  {{ customMsgService.translate('error') }}: {{ customMsgService.translate('theField') }}  {{ customMsgService.translate('tooltype') }}   {{ customMsgService.translate('isRequired') }}</kendo-formerror>

                    </kendo-formfield>              
             

                    <kendo-formfield orientation="horizontal">
                        <kendo-label class="k-label" [for]="refSubTipoFerramenta" [text]="customMsgService.translate('toolsubtypes')"> </kendo-label>
                        <kendo-dropdownlist formControlName="refSubTipoFerramenta"
                        textField="descricao"
                        valueField="id"
                        [defaultItem]="placeHolderSubtipoFerramenta"

                        [data]="listItemsSubTiposFiltrados"  #refSubTipoFerramenta >
                        </kendo-dropdownlist>
                    
                    </kendo-formfield>
                    <kendo-formfield orientation="horizontal">
                        <kendo-label class="k-label" [for]="descricao" [text]="customMsgService.translate('description')"> </kendo-label>
                        <kendo-textarea formControlName="descricao" #descricao > </kendo-textarea>
                       
                    </kendo-formfield>

                    <kendo-formfield orientation="horizontal">
                        <kendo-label [for]="bloqueada" [text]="customMsgService.translate('bloqueada')"> </kendo-label>
                        <!-- <kendo-switch #descontinuado formControlName="descontinuado"> </kendo-switch> -->
                        <input type="checkbox" #bloqueada formControlName="bloqueada" kendoCheckBox />
                        
                    </kendo-formfield>
                    <kendo-formfield orientation="horizontal">
                        <kendo-label [for]="abatida" [text]="customMsgService.translate('abatida')"> </kendo-label>
                        <!-- <kendo-switch #descontinuado formControlName="descontinuado"> </kendo-switch> -->
                        <input type="checkbox" #abatida formControlName="abatida" kendoCheckBox />
                        
                    </kendo-formfield>
                  
                    <kendo-formfield orientation="horizontal">
                        <kendo-label [for]="avariada" [text]="customMsgService.translate('avariada')"> </kendo-label>
                        <!-- <kendo-switch #descontinuado formControlName="descontinuado"> </kendo-switch> -->
                        <input type="checkbox" #avariada formControlName="avariada" kendoCheckBox />
                        
                    </kendo-formfield>
              
                        <kendo-dialog-actions>
                            <button kendoButton (click)="cancelChanges()">
                                {{ customMsgService.translate('cancel') }}
                            </button>
                            <button
                              kendoButton
                              (click)="saveChanges()"
                              themeColor="primary"
                              [disabled]="!formGroup.valid"
                            >
                            {{ customMsgService.translate('saveChanges') }}
                            </button>
                          </kendo-dialog-actions>
                  
                </fieldset>
            </form>

